
//54
Object.defineProperty(exports, "__esModule", { value: true });
require("./ToggleSwitch.st.css");
 module.exports.default = require("stylable/runtime").create(
    "root",
    "ToggleSwitchLayout3153479140",
    {"root":"ToggleSwitchLayout3153479140--root","rootWidth":"48px","rootHeight":"24px","trackWidth":"48px","trackHeight":"24px","knobWidth":"20px","knobHeight":"20px","knobMovementRange":"13px"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/toggle-switch/ToggleSwitchLayout.st.css
// module id = 1276
// module chunks = 0